import { CORE_SECTOR } from './runConstants';

export const BOUNTY_TAG_REWARD = 2;

const validCell = (index) =>
  Number.isInteger(index) && index >= 0 && index < 25;

const getBountyTagAttempt = (game) => {
  const attempt = game.bountyTag?.attempt;
  return !game.lastStandProtocol?.pending &&
    game.floor < CORE_SECTOR &&
    attempt?.floor === game.floor &&
    attempt.roomId === game.roomId &&
    validCell(attempt.targetIndex)
    ? attempt
    : null;
};

export const getBountyTagState = (game) => {
  const owned = !!game.relics?.includes('bountyTag');
  const canMark =
    owned &&
    game.phase === 'ready' &&
    game.floor < CORE_SECTOR &&
    !game.lastStandProtocol?.pending &&
    game.doorBoard?.length === 25;
  const attempt = getBountyTagAttempt(game);
  const targetIndex = canMark
    ? validCell(game.bountyTag?.targetIndex)
      ? game.bountyTag.targetIndex
      : null
    : attempt?.targetIndex ?? null;
  return {
    owned,
    canMark,
    targetIndex,
    armed: canMark && targetIndex !== null,
  };
};

export const markBountyTile = (game, targetIndex) =>
  getBountyTagState(game).canMark && validCell(targetIndex)
    ? { ...game, bountyTag: { targetIndex, attempt: null } }
    : game;

export const clearBountyTag = (game) =>
  getBountyTagState(game).canMark
    ? { ...game, bountyTag: { targetIndex: null, attempt: null } }
    : game;

// Lock and spend the mark at launch. Keep the target on the saved attempt so
// landing, Mirror Chip, and Last Stand cannot move or replay the bounty.
export const startBountyTagThrow = (game) => {
  const state = getBountyTagState(game);
  return {
    ...game,
    bountyTag: {
      targetIndex: null,
      attempt: state.armed
        ? {
            floor: game.floor,
            roomId: game.roomId,
            targetIndex: state.targetIndex,
          }
        : null,
    },
  };
};

export const getBountyTagOutcome = (game, success) => {
  const attempt = getBountyTagAttempt(game);
  if (!attempt || !validCell(game.landingIndex)) return null;
  const matched = game.landingIndex === attempt.targetIndex;
  const earned = matched && success ? BOUNTY_TAG_REWARD : 0;
  return {
    id: 'bountyTag',
    targetIndex: attempt.targetIndex,
    matched,
    earned,
    message: earned
      ? `Bounty claimed: landed on square ${
          attempt.targetIndex + 1
        } and cleared the room. +${earned} shards.`
      : matched
      ? 'Marked tile hit, but the room was not cleared. Mark spent; no bonus shards.'
      : `Missed marked square ${
          attempt.targetIndex + 1
        }. Mark spent; no bonus shards.`,
  };
};
